var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_320","data-name":"Group 320","transform":"translate(-1315 -5514)"},[React.createElement("circle",{"id":"Ellipse_4","data-name":"Ellipse 4","cx":"19.735","cy":"19.735","r":"19.735","transform":"translate(1315 5514)","fill":"#bcbcbc","key":0}),React.createElement("path",{"id":"Icon_awesome-facebook-f","data-name":"Icon awesome-facebook-f","d":"M12.045,11.728l.579-3.773H9V5.506A1.887,1.887,0,0,1,11.13,3.467h1.646V.255A20.073,20.073,0,0,0,9.855,0C6.873,0,4.924,1.807,4.924,5.079V7.954H1.609v3.773H4.924v9.122H9V11.728Z","transform":"translate(1327.391 5523)","fill":"#fff","key":1})]));
}

FacebookInline.defaultProps = {"width":"39.47","height":"39.47","viewBox":"0 0 39.47 39.47"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
